<template>
  <div class="block md:hidden text-center pt-20 text-lxl px-16 text-gray-700">
    We're sorry, this page can only be viewed on desktop.
  </div>
  <div class="hidden md:block">
    <div
      v-if="pathName === '/platform/login' || !loggedIn"
      class="bg-white"
      style="min-height: 100vh"
    >
      <LoginPage />
    </div>

    <div v-else class="bg-white relative">
      <PageHeader
        class="fixed top-0 left-0 right-0 h-16"
        :loggedIn="loggedIn"
      />

      <div class="flex h-full mt-16" v-if="pathName === '/'">
        <HomePage />
      </div>

      <div class="flex h-full mt-16" v-if="pathName === '/platform'">
        <HomePage />
      </div>

      <div class="flex" v-if="pathName === '/platform/reference'">
        <div class="relative">
          <div
            class="overflow-y-scroll border-r border-gray-200"
            style="min-height: 100vh"
          >
            <MainSidebar
              :groups="state.groups"
              :onSelect="onSelect"
              :selectedSectionId="selectedSectionId"
            ></MainSidebar>
          </div>
        </div>

        <div
          class="flex-fill overflow-y-scroll flex-1 relative text-gray-900"
          style="height: 100vh"
          id="group"
        >
          <GroupPage :group="selectedGroup"></GroupPage>
        </div>
      </div>
    </div>

    <div class="flex h-full mt-16" v-if="pathName === '/platform/examples'">
      <EmptyPage />
    </div>

    <div class="flex h-full mt-16" v-if="pathName === '/platform/account'">
      <AccountPage />
    </div>

    <div class="flex h-full mt-16" v-if="pathName === '/platform/licence'">
      <EmptyPage />
    </div>
  </div>
</template>

<script>
import LoginPage from "./components/LoginPage.vue";
import GroupPage from "./components/GroupPage.vue";
import AccountPage from "./components/AccountPage.vue";
import MainSidebar from "./components/MainSidebar.vue";
import PageHeader from "./components/PageHeader.vue";
import HomePage from "./components/HomePage.vue";
import { isLoggedIn } from "./api.js";
import { state } from "./data/state";
import EmptyPage from "./components/EmptyPage.vue";

const pathName = window.location.pathname;

export default {
  name: "App",
  data: () => {
    return {
      state,
      selectedGroupId: "introduction1",
      selectedSectionId: "introduction1",
      pathName: pathName,
      loggedIn: false,
    };
  },
  methods: {
    onSelect: function (g, s, skipScroll) {
      this.selectedGroupId = g;
      this.selectedSectionId = s;

      if (skipScroll) {
        return;
      }

      setTimeout(() => {
        document.getElementById(this.selectedSectionId).scrollIntoView({
          block: "start",
        });
      });
    },
  },
  computed: {
    selectedGroup: function () {
      return this.state.groups.filter((group) => {
        return group.id === this.selectedGroupId;
      })[0];
    },
    selectedSection: function () {
      return this.selectedGroup.sections.filter((section) => {
        return section.id === this.selectedSectionId;
      })[0];
    },
  },
  props: [],
  components: {
    MainSidebar,
    GroupPage,
    LoginPage,
    PageHeader,
    HomePage,
    AccountPage,
    EmptyPage,
  },
  mounted: async function () {
    this.loggedIn = await isLoggedIn();
  },
};
</script>

<style></style>
